import { EntityType } from '@lib/deals';
import { Tooltip } from '@material-ui/core';
import CompanyDefaultIcon from '@icon/company-default';
import ContentDefaultIcon from '@icon/content-default';
import PersonDefaultIcon from '@icon/person-default';
import { BsFillQuestionDiamondFill } from '@icon/react-icons';
import { forwardRef } from 'react';
import styled from 'styled-components';
import WorkingTitleIcon from '@icon/working-title-default';
import BookTitleIcon from '@icon/book-title-default';

const entityIconAdapter = {
  [EntityType.company]: CompanyDefaultIcon,
  [EntityType.content]: ContentDefaultIcon,
  [EntityType.person]: PersonDefaultIcon,
  WT: WorkingTitleIcon,
  BN: BookTitleIcon,
  unknown: props => <BsFillQuestionDiamondFill color="error" {...props} />,
};

type EntityIconProps = {
  type?: string;
  noTooltip?: boolean;
  disabled?: boolean;
} & React.SVGProps<SVGSVGElement>;

export const EntityIcon = styled(
  forwardRef(({ type, noTooltip = false, disabled, ...props }: EntityIconProps, ref) => {
    const Icon = entityIconAdapter[type] || entityIconAdapter.unknown;
    const element = <Icon height="2em" width="2em" {...(noTooltip ? { ref } : {})} {...props} />;
    return noTooltip ? (
      element
    ) : (
      <Tooltip title={type} ref={ref}>
        {element}
      </Tooltip>
    );
  })
)`
  ${({ disabled = false }) => disabled && `filter: grayscale(1);`}
`;
